import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaWhatsapp, FaFacebook, FaInstagram } from "react-icons/fa";
import logo from "../assets/racketAndBall.jpg";

function Footer() {
  return (
    <footer
      className="text-white mt-5 pt-5"
      style={{ backgroundColor: "#03055B" }}
    >
      <Container>

        <Row className="mb-4">

          {/* BRAND SECTION */}
          <Col xs={12} md={4} className="mb-4">
            <div className="d-flex align-items-center mb-3">
              <img
                src={logo}
                alt="ATA Logo"
                style={{ width: "50px", height: "50px" }}
                className="me-2"
              />
              <h5 className="mb-0 fw-bold">ATA</h5>
            </div>

            <p style={{ fontSize: "0.9rem", opacity: 0.85 }}>
              Adeleke Tennis Academy is dedicated to developing disciplined,
              skilled, and confident tennis players through professional coaching.
            </p>

            <Button variant="light" size="sm" href="/contact">
              Book Training
            </Button>
          </Col>

          {/* QUICK LINKS */}
          <Col xs={12} md={4} className="mb-4">
            <h6 className="fw-bold mb-3">Quick Links</h6>
            <ul className="list-unstyled d-flex flex-column gap-2">
              <li><Link className="text-white text-decoration-none" to="/">Home</Link></li>
              <li><Link className="text-white text-decoration-none" to="/aboutme">About</Link></li>
              <li><Link className="text-white text-decoration-none" to="/gallery">Gallery</Link></li>
              <li><Link className="text-white text-decoration-none" to="/testimonial">Testimonials</Link></li>
              <li><Link className="text-white text-decoration-none" to="/contact">Contact</Link></li>
            </ul>
          </Col>

          {/* CONTACT INFO */}
          <Col xs={12} md={4} className="mb-4">
            <h6 className="fw-bold mb-3">Contact Info</h6>

            <p className="mb-1">📍 United States / Remote Coaching</p>
            <p className="mb-1">📞 +1 18625764553</p>
            <p className="mb-3">📧 adeleketennisacademy@gmail.com</p>

            <p className="mb-1 fw-bold">Training Hours</p>
            <p className="mb-0">Mon - Sat: 8AM - 6PM</p>
          </Col>

        </Row>

        {/* SOCIAL + CTA */}
        <Row className="align-items-center mb-3">
          <Col className="text-center">

            <a
              href="https://wa.me/your-whatsapp-number"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white me-3"
            >
              <FaWhatsapp size={22} />
            </a>

            <a
              href="https://web.facebook.com/julisky06"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white me-3"
            >
              <FaFacebook size={22} />
            </a>

            <a
              href="https://www.instagram.com/AdelekeTennisAcademy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white"
            >
              <FaInstagram size={22} />
            </a>

          </Col>
        </Row>

        <hr className="border-secondary" />

        {/* COPYRIGHT */}
        <div className="text-center pb-3">
          <small>
            &copy; {new Date().getFullYear()} Adeleke Tennis Academy. All Rights Reserved.
          </small>
        </div>

      </Container>
    </footer>
  );
}

export default Footer;